import React from 'react'

import Input from 'Components/Input'

export default React.memo(props => <Input disabled={props.disabled} title={props.title} onChange={props.onChangeInput}
             multiLine={true} rows={2}
             value={props.data} id={props.name}/>)


// WEBPACK FOOTER //
// ./app/Utilitaire/Component/DataComponent/Components/TextArea.js